import { BaseElementWidget, CardCascaderWidget, SPI, uniqueKeyGenerator, ViewType, Widget } from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Tree,
    widget: ['card-cascader', 'cardCascader', 'CardCascader']
  })
)
export class CustomCardCascaderWidget extends CardCascaderWidget {
  protected async onNodeSelected(node) {
    await super.onNodeSelected(node);
    if (node.value.data) {
      this.reloadActiveRecords(node.value.data);
    }
  }

  protected async onNodeUnselected(node) {
    await super.onNodeUnselected(node);
    this.reloadActiveRecords(undefined);
  }

  @Widget.Method()
  protected async onSearch(keywords, rootNode?) {
    if (!rootNode) {
      return;
    }
    const { metadata, parentNode } = rootNode.value;
    const isTree = !!metadata.selfReferences;
    if (keywords && isTree) {
      await super.onSearch(keywords, rootNode);
    } else if (keywords) {
      await super.onSearch(keywords, rootNode);
    } else if (parentNode) {
      await super.onSearch(keywords, rootNode);
    } else {
      const firstRootNode = this.rootNodes?.[0];
      if (firstRootNode) {
        await this.fetchNodeData(firstRootNode, metadata, true);
        await this.onClearSearch();
      }
    }
  }

  protected async fetchNodeData(node, metadata, firstRootNode?: boolean) {
    const { rootNodes } = this;
    if (!rootNodes) {
      return;
    }
    const { key, title } = metadata;
    const newRootNode = {
      title,
      key: uniqueKeyGenerator(),
      value: {
        metadata,
        pagination: { ...this.defaultPagination },
        parentNode: firstRootNode ? null : node
      },
      children: [],
      isLeaf: false
    };
    this.loadIdempotentKey[node.key] = uniqueKeyGenerator();
    const oldKey = this.loadIdempotentKey[node.key];
    const results = await this.load(() => this.fetchData(newRootNode, true));
    if (oldKey === this.loadIdempotentKey[node.key]) {
      this.fillChildren(newRootNode, results);
      const index = rootNodes.findIndex((v) => v.value.metadata.key === key);
      if (index === -1) {
        rootNodes.push(newRootNode);
      } else {
        rootNodes.splice(index, rootNodes.length - index, newRootNode);
      }
    }
  }
}
